// Remove Group Users
export const REMOVE_GROUP_USERS_REQUEST = 'REMOVE_GROUP_USERS_REQUEST';
export const REMOVE_GROUP_USERS_DONE = 'REMOVE_GROUP_USERS_DONE';
export const REMOVE_GROUP_USERS_FAILED = 'REMOVE_GROUP_USERS_FAILED';
